import wrapWithProvider from "./store";
import pageWrapper from "./wrapPageElement";
export const wrapRootElement = wrapWithProvider;
import {
	forcedLogoutKey, customerTokenKey, customerSessionKey, loopTokenKey, REDIRECT_URL, STORE_ID
} from "./src/utils/constants";
import getStorageValue from "helpers/get-storage-value";

import "./src/styles/global.css";

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
	const isModal = location?.state?.modal;
	const preventUpdateScroll = location?.state?.preserveScroll;

	if (isModal || preventUpdateScroll)
		return false;

	return true;
};

export const onClientEntry = () => {
	const forcedLogout = JSON.parse(localStorage.getItem(forcedLogoutKey));
	const customerToken = JSON.parse(localStorage.getItem(customerTokenKey));
	if (!forcedLogout && customerToken) {
		const logOutUrl = `https://shopify.com/${STORE_ID}/auth/logout?id_token_hint=${getStorageValue(
			customerTokenKey,
			"id_token",
			"local",
		)}&post_logout_redirect_uri=${REDIRECT_URL}`;

		window.localStorage.removeItem(customerTokenKey);
		window.sessionStorage.removeItem(customerSessionKey);
		window.localStorage.removeItem(loopTokenKey);
		window.location.href = logOutUrl;
	}
	localStorage.setItem(forcedLogoutKey, "true");
}

export const wrapPageElement = pageWrapper;